import { render, staticRenderFns } from "./CollectionConfig.vue?vue&type=template&id=07aedbd1&scoped=true"
import script from "./CollectionConfig.vue?vue&type=script&lang=js"
export * from "./CollectionConfig.vue?vue&type=script&lang=js"
import style0 from "./CollectionConfig.vue?vue&type=style&index=0&id=07aedbd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aedbd1",
  null
  
)

export default component.exports